// src/api/questionnaireQuestions.js

import { get, post, patch, destroy } from "@/lib/fetcher";

const basePath = "/admin/questionnaire_questions";

export async function getQuestions() {
    return await get(basePath);
}

export async function postQuestion(data) {
    return await post(basePath, data);
}

export async function patchQuestion(id, data) {
    return await patch(basePath, id, data);
}

export async function deleteQuestion(id) {
    return await destroy(`${basePath}/${id}`);
}

export async function patchQuestionOrder(data) {
    return await patch("/admin/questionnaire_questions/reorder", null, { questions: data });
}
